import React from "react";
import Dashboard from "../../assets/svgs/Navigator/DashboardFigmaIcon.svg";
import Menu from "../../assets/svgs/Navigator/MenuFigmaIcon.svg";
import Orders from "../../assets/svgs/Navigator/OrdersFigmaIcon.svg";
import Profile from "../../assets/svgs/Navigator/ProfileFigmaIcon.svg";
import Wallet from "../../assets/svgs/Navigator/Wallet.svg";
import Rating from "../../assets/svgs/Navigator/Rating.svg";

import Report from "../../assets/svgs/Navigator/Reports.svg";
import Discount from "../../assets/svgs/Navigator/discountvoucher.svg";

import Logout from "../../assets/svgs/Navigator/LogoutIcon.svg";

import ConnectedTvIcon from '@mui/icons-material/ConnectedTv';

export const DashboardIcon: React.FC = () => (
  <img src={Dashboard} alt="Dashboard" />
);

export const MenuIcon: React.FC = () => <img src={Menu} alt="Menu" />;
export const DiscountIcon: React.FC = () => <img src={Discount} alt="Discount" />;
export const WalletIcon: React.FC = () => <img src={Wallet} alt="Wallet" />;
export const RatingIcon: React.FC = () => <img src={Rating} alt="Rating" />;
export const ReportIcon: React.FC = () => <img src={Report} alt="Report" />;

export const OrdersIcon: React.FC = () => <img src={Orders} alt="Orders" />;

// Keep other icon components as placeholders for now
export const ProfileIcon: React.FC = () => <img src={Profile} alt="Profile" />;
export const LiveIcon: React.FC = () => <ConnectedTvIcon />;
export const LogoutIcon: React.FC = () => <img src={Logout} alt="Logout" />;
